module.exports = __webpack_public_path__ + "static/media/Flex.eb20cfe4.png";